import Link from "next/link";
import { useTranslations } from "next-intl";
import { CookieConsentConfig } from "@/lib/nexus-app";
import { RichTextOrFallback } from "./RichTextOrFallback";
import { BANNER_LINK_CLASS } from "./utils/cookie-consent.utils";

export function CookieConsentAllCookiesCard({
  content,
  t,
  onAccept,
}: {
  content: CookieConsentConfig | null | undefined;
  t: ReturnType<typeof useTranslations<"CookieConsent">>;
  onAccept: () => void;
}) {
  return (
    <article className="flex h-full flex-col rounded-xl border border-gray-3 bg-white p-6">
      <h3 className="text-lg font-semibold text-dark">
        {content?.allTitle || t("allTitle")}
      </h3>
      <div className="mt-3 space-y-4 text-sm leading-6 text-body">
        <p>
          <span className="block font-semibold text-dark">
            {content?.functionalTitle || t("functionalTitle")}
          </span>
          <RichTextOrFallback
            value={content?.functionalDescription}
            fallback={t("functionalDescription")}
            linkClassName={BANNER_LINK_CLASS}
          />
        </p>
        <p>
          <span className="block font-semibold text-dark">
            {content?.marketingTitle || t("marketingTitle")}
          </span>
          <RichTextOrFallback
            value={content?.marketingDescription}
            fallback={t.rich("marketingDescription", {
              googleLink: (chunks) => (
                <Link
                  href="https://policies.google.com/technologies/partner-sites"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline underline-offset-2"
                >
                  {chunks}
                </Link>
              ),
            })}
            linkClassName="underline underline-offset-2"
          />
        </p>
      </div>
      <div className="mt-auto pb-8 pt-14">
        <button
          type="button"
          onClick={onAccept}
          className="mx-auto block w-full max-w-[340px] rounded-lg bg-blue px-4 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-blue-dark"
        >
          {content?.acceptAllLabel || t("acceptAll")}
        </button>
      </div>
    </article>
  );
}
